// @ts-ignore
import createBizTheme from './createBizTheme'

const businessTheme = createBizTheme()

// Only for debug
if (process.env.NODE_ENV !== 'production') {
  // @ts-ignore
  window.businessTheme = businessTheme
}

export default businessTheme
